export const PARTICIPANT_AUTH_TOKEN_EXPIRES_HEADER =
  'participant-auth-token-expires';
